import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ResizeObserverDirective } from './directives/resize-observer';
import { ParentMessagesSender } from './services/parent-messages-sender';
import { ParentMessagesListener } from './services/parent-messages-listener';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ResizeObserverDirective],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class App implements OnInit {
  private parentMessagesSender = inject(ParentMessagesSender);
  private parentMessagesListener = inject(ParentMessagesListener);

  ngOnInit() {
    this.parentMessagesSender.getToken();
  }
}
